module.exports = __webpack_public_path__ + "img/bg-company-zl.a0788c6d.jpg";